import React from "react";
import TextInput from "../../../components/form/inputs/text-input/text-input";
import { emailReg, showToast } from "../../../utils/utils";
import LogoLayout from "../../../components/logolayout/logolayout";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../../config/axios";

export default function RegisterStep1Page() {
  const navigate = useNavigate();
  const onSubmit = async (form: any) => {
    try {
      const res = await axiosInstance.post(`auth/signup`, {
        role: "provider",
        email: form.email,
      });
      navigate("/register/step2", {
        state: { success: true, email: form.email, duration: res?.data?.duration },
      });
    } catch (error: any) {
      if (error.response.status == 409) showToast("Cette adresse e-mail est déjà utilisée");
    }
  };
  return (
    <LogoLayout onSubmit={onSubmit} submitTitle={"Continuer"} progress={25} hideBack={true}>
      <div className="d-flex flex-grow-1 flex-column">
        <TextInput
          name="email"
          autocomplete="off"
          type="email"
          placeHolder="adresse@mail.fr"
          label="Quel est ton email ?"
          validate={(val: any) => (!emailReg.test(val) ? "L’adresse e-mail est obligatoire" : true)}
        />
        <span className="legend gray"> Tu devras confirmer ce mail plus tard</span>
        <div className="d-flex flex-grow-1 align-items-end">
          <div className="gray current">
            En créant un compte avec mon e-mail, Google, Facebook ou Apple, j’accepte les{" "}
            <a href="https://www.kova-app.com/cgu" className="skewed-text">
              <span className="">Conditions Générales d’Utilisation et de Vente</span>
            </a>{" "}
            de Kova et je reconnais avoir pris connaissance de{" "}
            <a href="https://www.kova-app.com/cgu" className="skewed-text">
              <span className="">la Politique de Confidentialité</span>
            </a>
            .
          </div>
        </div>
      </div>
    </LogoLayout>
  );
}
